// 코스피/코스닥 노출 비중 — 국내 보유분을 시장별로 쪼개 그로스 대비 %로 표시.
import React from "react";
import { portfolioExposure } from "../lib/exposure";
import { krMarketOf, krMarketLabel, krMarketColor, isKR } from "../lib/krMarket";

const fmtKRW = (n) => (n == null || isNaN(n) ? "—" : "₩" + Math.round(n).toLocaleString("ko-KR"));

export default function KrMarketSplit({ holdings, marketData, exchangeRates }) {
  const { rows, grossKRW } = portfolioExposure(holdings, marketData, exchangeRates);

  // 국내분만 시장별 롱/숏 집계. 판별 실패분은 '미상'으로 따로 세서 조용히 사라지지 않게.
  const agg = { KS: { long: 0, short: 0, n: 0 }, KQ: { long: 0, short: 0, n: 0 }, unknown: { long: 0, short: 0, n: 0 } };
  let krTotal = 0;
  for (const r of rows) {
    if (!isKR(r.market)) continue;
    const km = krMarketOf(r, marketData) || "unknown";
    agg[km][r.short ? "short" : "long"] += r.exposureKRW;
    agg[km].n += 1;
    krTotal += r.exposureKRW;
  }
  if (!krTotal) return null;

  const pctOfGross = (v) => (grossKRW ? (v / grossKRW) * 100 : 0);
  const items = [["KS", agg.KS], ["KQ", agg.KQ], ["unknown", agg.unknown]]
    .filter(([, a]) => a.n > 0);

  return (
    <div style={{
      background: "#fff", border: "1px solid #e8e8e8", borderRadius: 12,
      padding: "14px 18px", marginBottom: 24,
    }}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 8, marginBottom: 10 }}>
        <span style={{ fontSize: 13, fontWeight: 800, color: "#1a1a2e" }}>국내 시장별 노출</span>
        <span style={{ fontSize: 11, color: "#aaa" }}>
          그로스 대비 · 국내 합계 {pctOfGross(krTotal).toFixed(1)}%
        </span>
      </div>

      {/* 누적 막대 — 국내분 안에서의 구성비 */}
      <div style={{ display: "flex", height: 10, borderRadius: 5, overflow: "hidden", background: "#f2f2f4", marginBottom: 10 }}>
        {items.map(([k, a]) => (
          <div key={k} title={`${krMarketLabel(k) || "미상"} ${((a.long + a.short) / krTotal * 100).toFixed(1)}%`}
            style={{ width: `${(a.long + a.short) / krTotal * 100}%`, background: krMarketColor(k) }} />
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: `repeat(auto-fit, minmax(190px, 1fr))`, gap: 10 }}>
        {items.map(([k, a]) => {
          const tot = a.long + a.short;
          return (
            <div key={k} style={{ borderLeft: `3px solid ${krMarketColor(k)}`, paddingLeft: 10 }}>
              <div style={{ fontSize: 11, color: "#888", marginBottom: 3 }}>
                {krMarketLabel(k) || "시장 미상"} <span style={{ color: "#ccc" }}>· {a.n}종목</span>
              </div>
              <div style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", lineHeight: 1.2 }}>
                {pctOfGross(tot).toFixed(1)}%
                <span style={{ fontSize: 11, fontWeight: 400, color: "#aaa", marginLeft: 6 }}>
                  국내 중 {(tot / krTotal * 100).toFixed(0)}%
                </span>
              </div>
              <div style={{ fontSize: 11, color: "#888", marginTop: 3 }}>
                <span style={{ color: "#0a7c59" }}>롱 {pctOfGross(a.long).toFixed(1)}%</span>
                <span style={{ color: "#ddd", margin: "0 5px" }}>|</span>
                <span style={{ color: "#c0392b" }}>숏 {pctOfGross(a.short).toFixed(1)}%</span>
                <span style={{ color: "#ccc", marginLeft: 6 }}>{fmtKRW(tot)}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
